<template>
    <div>
      <Export_product_list/>
    </div>
  </template>
  
  <script>
  import Export_product_list from "@/components/adminArin/pos_system/warehouse/export_product/Export_product_list";
  export default {
    name: "ExportProduct",
    components: {
        Export_product_list
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  